import styled from "styled-components";

export const StyledApp = styled.div`
  background-color: var(--background);
  -webkit-tap-highlight-color: transparent;
`;
